import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-paper px-6 text-center">
          <div>
            <p className="font-display text-2xl font-bold">Algo saiu do lugar.</p>
            <p className="mt-2 text-sm text-ink-2">Recarregue a página para voltar ao estúdio.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
